var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrpDwnIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64645 6.31051C3.84171 6.11525 4.15829 6.11525 4.35355 6.31051L8 9.95696L11.6464 6.31051C11.8417 6.11525 12.1583 6.11525 12.3536 6.31051C12.5488 6.50577 12.5488 6.82235 12.3536 7.01762L8.35355 11.0176C8.15829 11.2129 7.84171 11.2129 7.64645 11.0176L3.64645 7.01762C3.45118 6.82235 3.45118 6.50577 3.64645 6.31051Z",
    fill: "#2B244C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrpDwnIcon);
export default __webpack_public_path__ + "static/media/DrpDwnIcon.0e3991da25ee19d29c6e57002be48b5f.svg";
export { ForwardRef as ReactComponent };